export const getUserFullName = user =>
  user.firstName ? `${user.firstName} ${user.lastName}` : user.identifier;



// WEBPACK FOOTER //
// ./src/utils/common.js